/* eslint-disable require-yield */
import {
  all, takeLatest,
} from 'redux-saga/effects';

function* handleLocationChange({ payload }) {
  return payload;
}

export default function* moduleNameSagas() {
  yield all([
    // to use below pattern, 'connected-react-router' is required in dependencies.
    takeLatest('@@router/LOCATION_CHANGE', handleLocationChange),
  ]);
}
